<template>
  <form-wizard ref="add_pkb_form" color="#39C0ED"  @on-complete="addConfirmation">
    <h2 slot="title"></h2>
    <!-- <tab-content title="Service info" :before-change="()=>validateStep('childServiceInfoComponent')"> -->
      <tab-content title="Service Information" :before-change="()=>validateStep('childServiceInfoComponent')">
        <info-card @keluhanServiceSparepart="dataServiceSparepart" :pkb="pkb" ref="childServiceInfoComponent"/>
      </tab-content>
      <tab-content title="Keluhan dan Analisa" >
        <keluhan-card @data="dataKeluhan" :pkb="pkb" ref="childKeluhanComponent"/>         
      </tab-content>
      <tab-content title="Check Kelengkapan" >
        <kelengkapan-card :pkb="pkb" ref="childKelengkapanComponent"/>         
      </tab-content>   
      
      <!-- <tab-content title="Service dan Sparepart" >
        <serviceSparepart-card :pkb="pkb" ref="childServiceSparepartComponent"/>
      </tab-content> -->
      <tab-content title="Service Information" :before-change="()=>validateStep('childServiceComponent')">
        <service-card @data="dataService" :pkb="pkb" ref="childServiceComponent"/>
      </tab-content>
      <tab-content title="SparePart Information" :before-change="()=>validateStep('childPartComponent')">
        <part-card @data="dataPart" :pkb="pkb" ref="childPartComponent"/>
      </tab-content>
      

  </form-wizard> 
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  import InfoCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/InfoCardPKB.vue";
  import KeluhanCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/KeluhanCard.vue";
  import KelengkapanCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/KelengkapanCard.vue";
  //import ServiceSparepartCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/ServiceSparepartCard.vue";
  import ServiceCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/ServiceCard.vue";
  import PartCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/PartCard.vue";
  import Swal from 'sweetalert2';
 
  export default {
     name: "add-pkb",

    props: {
      data_id: Object
    },

    components: {
      //ValidationError,
      FormWizard,
      TabContent,
      "info-card": InfoCard,
      "keluhan-card": KeluhanCard,
      "kelengkapan-card": KelengkapanCard,
     // "serviceSparepart-card": ServiceSparepartCard
     
      "service-card": ServiceCard,
      "part-card": PartCard,
      },

    mixins: [formMixin],

    data: () => ({
      
      pkb : [],
    }),

    created() {
      //this.getLastNo();
      if(this.data_id){
      this.pkb.pkb_service_estimate_id = this.data_id.id
      }
    },

   

    methods: {
      // async getLastNo(){
      //      await this.$store.dispatch("workshop_pkb/last_no")
      //      this.pkb.pkb_no =  await this.$store.getters["workshop_pkb/pkb"]
        
           
      //   this.$refs.procurement_order_no_input.$el.focus();
      //   this.$refs.procurement_order_remark_input.$el.focus();
      // },
      

       async addConfirmation() {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addPkb()
        }
      });
    },


      //fungsi saat add data
      async addPkb() {
       
       //ambil data dari masing" child dengan manjalankan fungsi getData 
         this.$refs.childKeluhanComponent.getData()
         this.$refs.childServiceComponent.getData()
         this.$refs.childPartComponent.getData()
 
 //definisikan var data
        const data = {
          type: "workshop_pkbs",

      // pkb_no: this.pkb.pkb_no,
      pkb_datetime: this.pkb.pkb_datetime,
      
      pkb_spion: this.pkb.pkb_spion,
      pkb_battery_1: this.pkb.pkb_battery_1,
      pkb_battery_2: this.pkb.pkb_battery_2,
      pkb_rak_depan: this.pkb.pkb_rak_depan,
      pkb_rak_belakang: this.pkb.pkb_rak_belakang,
      pkb_keluhan: this.pkb.keluhan,
      pkb_service: this.pkb.service,
      pkb_part: this.pkb.part,
      pkb_kaset_cd: this.pkb.pkb_kaset_cd,
      pkb_service_estimate_id	: this.pkb.pkb_service_estimate_id,
      pkb_repeat_order: this.pkb.pkb_repeat_order,
      pkb_catatan: this.pkb.pkb_catatan,
      pkb_perintah_kerja: this.pkb.pkb_perintah_kerja,
      pkb_teknisi: this.pkb.pkb_teknisi,
      // pkb_service_advisor: this.pkb.pkb_service_advisor,
      pkb_payment_plan: this.pkb.pkb_payment_plan,
      pkb_work_order_type: this.pkb.pkb_work_order_type
        }

      //console.log(data)

        try {
          //kirim data ke server
        await this.$store.dispatch("workshop_pkb/add", data);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        //kembali ke list
        if(this.data_id){
          this.$parent.$parent.modalCloseCreatePkb();
        }
        else{
          this.$parent.$parent.modalCloseAdd();

      }
      } catch (e) {
        //panggil alert error
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      },

      ///get data from child  dataServiceSparepart
      dataServiceSparepart (value) {
          console.log(value) 
          console.log("ahahahah") 
         // this.$refs.childServiceSparepartComponent.getDataParent(value),
         //set value on child keluhan dengang menjalankan fungsi getDataParent dengan data keluhan
          this.$refs.childKeluhanComponent.getDataParent(value.keluhan)
          //create array service dengan lool data service
          // var arrayService=[]
          // value.service.forEach((value, index) => {
          //   var arrayS=[] 
          //   arrayS['id'] = value.id
          //   arrayS['pkb_service_master_id'] = value.service_estimate_service_master_id
          //   arrayS['pkb_service_discount'] = value.service_estimate_service_discount
          //   arrayS['pkb_service_remark'] = value.service_estimate_service_remark
          //  arrayService.push(arrayS)


          // });
          //  //create array service dengan lool data service
          // var arrayPart=[]
          // value.part.forEach((value, index) => {
          //   var arrayS=[]
          //   arrayS['id'] = value.id
          //   arrayS['pkb_spare_part_master_id'] = value.service_estimate_spare_part_master_id
          //   arrayS['pkb_spare_part_qty'] = value.service_estimate_spare_part_qty
          //   arrayS['pkb_spare_part_discount'] = value.service_estimate_spare_part_discount
          //   arrayS['pkb_spare_part_remark'] = value.service_estimate_spare_part_remark
          //  arrayPart.push(arrayS)


          // });
          
         //set value on child service dan part dengang menjalankan fungsi getDataParent dengan data array yang telah dibuat sebelumnya
          this.$refs.childServiceComponent.getDataParent(value.service,'add')
          this.$refs.childPartComponent.getDataParent(value.part,'add',value.warehouse)
         

      },

      ///get data from child  keluhan
      dataKeluhan (value) {
        this.pkb.keluhan = value
      },
      ///get data from child  service
      dataService (value) {
        this.pkb.service = value
      },
      ///get data from child  part
      dataPart (value) {
         console.log(value) 
        this.pkb.part = value
      },

//check validasi sebelum dapat berpindah bagian
      validateStep(name) {
      var refToValidate = this.$refs[name]
       return refToValidate.validateForm()
    },
    }
  };
</script>
